// extracted by mini-css-extract-plugin
export default {"documentIcon":"styles_documentIcon__YzB64"};